import React, {useEffect, useRef, useState} from "react";
import {toPersianDigit} from "../helper/helper";
import ArrowDown from "./svg/ArrowDown";

const BirthDatePickerWithSeparateSelect: React.FC<any> = ({date, setDate, onBirthDateChange}) => {


  const month = [
    {
      id: 1,
      text: "فروردین"
    },
    {
      id: 2,
      text: "اردیبهشت"
    },
    {
      id: 3,
      text: "خرداد"
    },
    {
      id: 4,
      text: "تیر"
    },
    {
      id: 5,
      text: "مرداد"
    },
    {
      id: 6,
      text: "شهریور"
    },
    {
      id: 7,
      text: "مهر"
    },
    {
      id: 8,
      text: "آبان"
    },
    {
      id: 9,
      text: "آذر"
    },
    {
      id: 10,
      text: "دی"
    },
    {
      id: 11,
      text: "بهمن"
    },
    {
      id: 12,
      text: "اسفند"
    },
  ];
  const yearSelectedRef = useRef<any>();
  const daySelectedRef = useRef<any>();
  const monthSelectedRef = useRef<any>();
  const badRef = useRef<any>();

  const dayRef = useRef<any>();
  const monthRef = useRef<any>();
  const yearRef = useRef<any>();

  const [daysRow, setDaysRow] = useState([]);
  const [showDay, setShowDay] = useState(false);
  const [showMonth, setShowMonth] = useState(false);
  const [showYear, setShowYear] = useState(false);

  const changeYear = (e: any) => {
    setDate((pre: any) => {
      return {...pre, year: parseInt(e.target.value)}
    })
  }

  useEffect(() => {

    let rowsDay: any = [];
    let c;

    if (date.month <= 6) {
      c = 31

    } else {
      c = 30
      if (date.day === 31) {
        setDate((pre: any) => {
          return {...pre, day: 1}
        })
      }
    }

    for (let i = 1; i <= c; i++) {
      rowsDay.push(<React.Fragment key={i}>
        <li value={i} ref={date.day === i ? daySelectedRef : badRef}
            style={{backgroundColor: date.day === i ? '#CCCCCCDF' : ''}} onClick={changeDay}
            defaultValue={date.day}>{toPersianDigit(i.toString())}</li>
      </React.Fragment>);
    }

    setDaysRow(rowsDay);
  }, [date.month, date.day]);


  useEffect(() => {
    const completeDate = `${date.year}${date.month > 9 ? date.month : `0${date.month}`}${date.day > 9 ? date.day : `0${date.day}`}`;
    // console.log(completeDate);
    onBirthDateChange(completeDate)
  }, [date]);

  useEffect(() => {
    daySelectedRef.current?.scrollIntoView();
    const conditions = (event: any) => {
      if (dayRef.current.contains(event.target)) return;
      if (showDay) setShowDay(false)
    }
    document.body.addEventListener('click', conditions)
    return () => document.body.removeEventListener('click', conditions)
  }, [showDay]);

  useEffect(() => {
    monthSelectedRef.current?.scrollIntoView();
    const conditions = (event: any) => {
      if (monthRef.current.contains(event.target)) return;
      if (showMonth) setShowMonth(false)
    }
    document.body.addEventListener('click', conditions)
    return () => document.body.removeEventListener('click', conditions)
  }, [showMonth]);

  useEffect(() => {
    yearSelectedRef.current?.scrollIntoView();
    const conditions = (event: any) => {
      if (yearRef.current.contains(event.target)) return;
      if (showYear) setShowYear(false)
    }
    document.body.addEventListener('click', conditions)
    return () => document.body.removeEventListener('click', conditions)
  }, [showYear]);

  const rows = [];
  for (let i = 1260; i <= 1409; i++) {
    // note: we are adding a key prop here to allow react to uniquely identify each
    // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
    // eslint-disable-next-line react/jsx-no-undef
    rows.push(<React.Fragment key={i}>
      <li value={i} ref={date.year === i ? yearSelectedRef : badRef}
          style={{backgroundColor: date.year === i ? '#CCCCCCDF' : ''}}
          onClick={changeYear}>{toPersianDigit(i.toString())}</li>
    </React.Fragment>);
  }


  const changeDay = (e: any) => {
    setDate((pre: any) => {
      return {...pre, day: parseInt(e.target.value)}
    })
  }

  const changeMonth = (e: any) => {
    // console.log(e.target.value);
    setDate((pre: any) => {
      return {...pre, month: parseInt(e.target.value)}
    })

  }


  const openDay = () => {
    setShowDay(!showDay);
  }

  const openMonth = () => {
    setShowMonth(!showMonth)
  }

  const openYear = () => {
    setShowYear(!showYear);
  }


  return (
    <div className="birth-date-picker-with-separate-select">
      <div className="birth-date-picker-with-separate-select__day-title">
        <div className="birth-date-picker-with-separate-select__title">
        <span>
          تاریخ تولد
        </span>
        </div>
        <div className="birth-date-picker-with-separate-select__day" onClick={openDay} ref={dayRef}>
          {/* <select name="day" id="" value={date.day} onChange={changeDay} ref={dayRef}> */}
          {/*  {daysRow} */}
          {/* </select> */}
          <span>
            {date.day}
            <ArrowDown/>
          </span>
          <ul className={`${showDay ? 'showDay' : 'hideDay'}`}>
            {daysRow}
          </ul>
        </div>
      </div>

      <div className="birth-date-picker-with-separate-select__month" ref={monthRef} onClick={openMonth}>
        <span>
          {month.find((item: any) => item.id === date.month)?.text}
          <ArrowDown/>
        </span>
        <ul className={`${showMonth ? 'showMonth' : 'hideMonth'}`}>
          {
            month.map((it: any, index: any) => {
              return <React.Fragment key={index}>
                <li value={it.id}
                    ref={month.find((item: any) => item.id === date.month)?.id === ++index ? monthSelectedRef : badRef}
                    style={{backgroundColor: month.find((item: any) => item.id === date.month)?.id === index ? '#CCCCCCDF' : ''}}
                    onClick={changeMonth}>{it.text}</li>
              </React.Fragment>
            })
          }
        </ul>
      </div>
      <div className="birth-date-picker-with-separate-select__year" onClick={openYear} ref={yearRef}>
         <span>
            {date.year}
           <ArrowDown/>
          </span>
        <ul className={`${showYear ? 'showYear' : 'hideYear'}`}>
          {rows}
        </ul>
      </div>
    </div>
  )
}

export default BirthDatePickerWithSeparateSelect;